var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5095 1H7.48861C4.9983 1 4.44823 2.24015 4.12819 3.76034L2.99805 9.17106H19L17.8699 3.76034C17.5499 2.24015 16.9998 1 14.5095 1Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56883 11.9012C1.70885 10.4011 1.99888 9.1709 4.61921 9.1709H17.3808C20.0011 9.1709 20.2912 10.4011 20.4312 11.9012L20.9912 17.992C21.1013 19.1621 20.1611 20.1723 18.961 20.1723H17.0808C16.0006 20.1723 15.8506 19.7122 15.6606 19.1421L15.4605 18.5421C15.1805 17.722 15.0005 17.1719 13.5603 17.1719H8.43969C6.99951 17.1719 6.78948 17.792 6.53945 18.5421L6.33942 19.1421C6.1494 19.7122 5.99938 20.1723 4.91925 20.1723H3.03901C1.83886 20.1723 0.898747 19.1621 1.00876 17.992L1.19878 15.9317",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99817 6.17041H1.99805",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 6.17041H19",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 1.16992V3.17017",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49902 3.17041H12.4994",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 13.1714H7.9994",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.1714H17.0004",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarParking);
export default __webpack_public_path__ + "static/media/car_parking.f15c7ee9711b5b680ecd973337bd7279.svg";
export { ForwardRef as ReactComponent };